import { GlLoader } from '@adl/component-loader'
import { useClientResource, useDevice } from '@crystal/core'

import logo from '../assets/icons/adi-club-logo.svg?inline'
import { EmailConfirmation } from '../components/EmailConfirmation'
import { Landing } from '../components/landing'
import { Login } from '../components/Login'
import { MembershipConsents } from '../components/MembershipConsents'
import { PasswordCreation } from '../components/PasswordCreation'

import { useConsents } from './consents-hook'
import { ScreenViews } from './types'

// Internal Loader component (copied from AccountPortal.tsx)
export function Loader() {
  const { getResourceUrl } = useClientResource()
  const { isMobile } = useDevice()
  return (
    <div
      style={{ height: isMobile ? '70vh' : '500px' }}
      className="gl-flex-display gl-flex-col gl-flex-align-items-center gl-flex-justify-content-center">
      <img height="25px" src={getResourceUrl(logo)}></img>
      <GlLoader className="gl-vspace-bpall-medium" />
    </div>
  )
}

/**
 * Hook that returns the component for the current screen view
 * @param screenId The screen ID to render
 * @returns The JSX element for the specified screen
 */
export const useCurrentScreenView = (screenId: ScreenViews): JSX.Element => {
  const consentsState = useConsents('registration')

  // Map of screen IDs to component rendering functions
  const screenViewMap: Record<ScreenViews, JSX.Element> = {
    [ScreenViews.LANDING_SCREEN]: <Landing />,
    [ScreenViews.CREATE_PASSWORD_SCREEN]: <PasswordCreation consentsState={consentsState} />,
    [ScreenViews.LOGIN_SCREEN]: <Login />,
    [ScreenViews.ACTIVATE_CONFIRMATION_SCREEN]: <EmailConfirmation />,
    [ScreenViews.RESET_PASSWORD_CONFIRMATION_SCREEN]: <EmailConfirmation />,
    [ScreenViews.LOADING_SCREEN]: <Loader />,
    [ScreenViews.MEMBERSHIP_CONSENTS]: <MembershipConsents />,
  }

  // Render the component only when needed
  return screenViewMap[screenId]
}
